module.exports = __webpack_public_path__ + "img/partner-logo-network-transparant-rgb.ae0a4547.png";